<template>
  <main>
    <Banner :info="bannerInfo" />
    <Eq />
		<Video ytId="NH-vGVNPV1s" />
    <Ad />
    <Certification />
  </main>
</template>

<script>
import Banner from "@/components/Banner"
import Eq from "./_eq"
import Video from '@/components/Video'
import Ad from "./_ad";
import Certification from "./_certification"

export default {
  components: { Banner, Eq, Video, Ad, Certification },
  data() {
    return {
      bannerInfo: {
        src: require("@/assets/images/lab/banner.jpg"),
        alt: "Laboratory",
      },
    };
  },
};
</script>